<template>
	<svg class="ks-videoeditor-wave" :class="{muted: muted}" :viewBox="view_box" preserveAspectRatio="none">
		<path v-if="d" class="ks-videoeditor-wave-fill" :d="d"></path>
		<line class="ks-videoeditor-wave-level" x1="0" x2="100%" :y1="level" :y2="level"></line>
	</svg>
</template>

<script>
import {load_waveform, MAX_WAVE_POINTS, WAVE_HEADROOM, wave_path} from './waveform.js'

// Waveform strip of a media file; the peaks are decoded once per url and cached
export default {
	props: {
		url: String,
		// Source offset and length in seconds of the part to draw
		from: Number,
		len: Number,
		// Volume 0-1; scales the waveform and sets the level line
		gain: Number,
		muted: Boolean,
		// Pixels per second
		zoom: Number
	},
	data () {
		return {
			// Frozen so Vue doesn't observe the peak array
			wave: null
		}
	},
	watch: {
		url: {
			handler (url) {
				this.wave = null;
				if (!url) return;
				load_waveform(url).then((wave) => {
					if (wave && !this._isDestroyed && url === this.url) this.wave = Object.freeze(wave);
				});
			},
			immediate: true
		}
	},
	computed: {
		points () {
			return _.clamp(Math.round(this.len * this.zoom / 2), 1, MAX_WAVE_POINTS);
		},
		view_box () {
			return "0 0 " + this.points + " 100";
		},
		d () {
			return this.wave ? wave_path(this.wave, this.from, this.len, this.points, this.gain) : null;
		},
		level () {
			return Math.round((100 - this.gain * WAVE_HEADROOM * 100) * 10) / 10;
		}
	}
}
</script>
